import setFieldValue from "@iewc/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from '@iewc/Store/Reducers'
import FileUpload from "@iewc/Widgets/CreateAccount/FileUpload";
import translate from '@insite/client-framework/Translate'
import Checkbox from '@insite/mobius/Checkbox'
import CheckboxGroup from '@insite/mobius/CheckboxGroup'
import GridContainer from '@insite/mobius/GridContainer'
import GridItem from '@insite/mobius/GridItem'
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    checkboxLabel: string;
    uploadTaxformContent: string;
}

const mapStateToProps = (state: CustomState) => ({
    file: state.customCreateAccountForm.fieldValues.file as any,
    taxExempt: state.customCreateAccountForm.fieldValues.taxExempt,
});

const mapDispatchToProps = {
    setFieldValue,
};

export interface TaxExemptionStyles {
    heading: TypographyProps;
    uploadFieldWrapper?: InjectableCss;
}

export const taxExemptionStyles: TaxExemptionStyles = {
    heading: {
        css: css`
            margin-top: 30px;
            margin-bottom: 0;
        `,
    },

    uploadFieldWrapper: {
        css: css`
            margin-bottom: 30px;
        `,
    },
};

const styles = taxExemptionStyles;

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

function TaxExemption({ heading, checkboxLabel, setFieldValue, taxExempt, file, uploadTaxformContent }: Props) {
    const UploadField = FileUpload as any;
    const [refreshkey, setRefreshKey] = React.useState(0);

    React.useEffect(() => {
        if (taxExempt !== "true") {
            setFieldValue({ key: "file", value: "" } as any);
        }
    }, [taxExempt]);

    return (
        <>
            <GridContainer>
                <GridItem width={12}>
                    <Typography {...styles.heading} variant="h2" as="h2">
                        {heading}
                    </Typography>
                </GridItem>
            </GridContainer>
            <GridContainer {...styles.uploadFieldWrapper}>
                <GridItem width={12}>
                    <CheckboxGroup>
                        <Checkbox
                            checked={taxExempt === "true"}
                            onChange={() => {
                                setFieldValue({ key: "taxExempt", value: taxExempt === "true" ? "false" : "true" });
                            }}
                        >
                            {checkboxLabel}
                        </Checkbox>
                    </CheckboxGroup>
                </GridItem>
                {taxExempt === "true" && (
                    <GridItem width={5}>
                        <UploadField heading={heading} copy={uploadTaxformContent} label={checkboxLabel} />
                    </GridItem>
                )}
            </GridContainer>
        </>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxExemption);
